<div class="container-fluid generalContainer">
  <div class="row">
    <div class="col-md-12 min-vh-100 d-flex flex-column justify-content-center">
      <div class="row">
        <div class="col-lg-6 col-md-8 mx-auto">
          <div class="card rounded shadow shadow-sm opacity loginContainer">
            <div class="card-header">
              <h3 class="mb-0 text-center loginTitle">Ingreso al sistema</h3>
            </div>
            <div class="card-body">
              <form class="form" role="form" autocomplete="off" id="formLogin" novalidate="" method="POST">
                <div class="text-center">
                  <img src="../../assets/farmer.png" alt="Campo" style="width: 370px;" />
                </div>
                <br />
                <button type="button" (click)="loginPopup()" class="btn btn-outline-success btn-block float-right"
                  id="btnLogin">
                  <img src="../../assets/azure.png" /> Ingresar</button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
